import { i18n } from '@/locales';
import { userLevelCode } from '../userLevel';
const userLevelCodeList = [
    'ALL',
    '42', // 'DIST_MASTER',
    '41', // 'DIST_ADMIN',
    '40', // 'DIST_USER',
    '32', // 'HUB_MASTER',
    '31', // HUB_ADMIN',
    '30', // 'HUB_USER',
];
export default userLevelCodeList.map((code) => ({
    text: userLevelCode[code]?.text ?? i18n.t('common.all'),
    value: code,
}));
